import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import ProjectHealthView from './ProjectHealthView';

const ProjectHealth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Project Health</title>
      </Helmet>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <div className="blur-container">
              <ProjectHealthView />
            </div>
            <div className="blur-content">
              <h1 className="blur-header">Under Development</h1>
            </div>
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
};

export default ProjectHealth;
